module.exports = __webpack_public_path__ + "img/tiktok.8166b471.svg";